module.exports = __webpack_public_path__ + "img/logo.5c8d8fe5.svg";